<template>
    <div class="list-detail">
        <div class="list-detail-container">
            <header><p>Member Detail<span style="font-weight: bold;"> - {{ customer.name }}</span></p><div class="x" @click="exit"></div></header>
            <div>
                <div v-for="loyal in loyalty">
                    <p>{{ loyal.text }}</p>
                    <p>{{ loyal.awarded }}</p>
                </div>
            </div>
            <div>
                <div class="coupon-item">
                    <p>Created</p>
                    <p>Title</p>
                    <p>Clicks</p>
                    <p>Redeemed</p>
                    <p>Expires</p>
                    <p>Status</p>
                </div>
                <div v-for="coupon in coupons" class="coupon-item" style="display: grid;grid-template-columns: 160px 300px 100px 160px 160px 90px">
                    <p>{{ format(coupon.created,'dd/MM/yyyy HH:mm') }}</p>
                    <p class="ellip">{{ coupon.field || coupon.campaignTitle }}</p>
                    <p>{{ coupon.clicks }}</p>
                    <p>{{ coupon.dateRedeemed > 0 && format(coupon.dateRedeemed,'dd/MM/yyyy HH:mm') || '' }}</p>
                    <p>{{ coupon.expires > 0 && format(coupon.expires,('dd/MM/yyyy HH:mm')) || '' }}</p>
                    <p>{{ coupon.status }}</p>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js';
import { format } from 'date-fns'

export default {
    props: ['item'],
    computed: {
        client_id () { return this.$store.state.client_id; }
    },
    data () {
        return {
            format,
            customer: {},
            ads: [],
            loyalty: [],
            coupons: []
        }
    },
    mounted () {
        console.log('memberDetail item',JSON.parse(JSON.stringify(this.item)));
        this.getData( this.item );

    },
    methods: {
        getData ( customer ) {
            WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id: customer._id },customer => {
                
                console.log('customer.loyaltyReards',customer.loyaltyReards);
                console.log('customer.rewarded',customer.rewarded);
                this.customer = customer;
                this.checkLoyalty()
                console.log('customer',JSON.parse(JSON.stringify(customer)));
                customer.redeemRewards.forEach(c => {
                    setTimeout(() => {
                        console.log('redeemReward',JSON.parse(JSON.stringify(c)));
                        var coupon = this.coupons.find(C => C._id == c.coupon_id);
                        console.log('coupon.status',coupon.title,coupon.status);
                    },4000);
                })
                customer.ads.forEach(ad => {
                    WebSoc.SEND('get',{ DB: 'jb-ads', _id: ad.ad_id },jbAD => {
                        WebSoc.SEND('get',{ DB: 'jb-coupons', _id: ad.coupon_id },coupon => {
                            console.log({
                                customer_id: customer._id,
                                ad: JSON.parse(JSON.stringify(ad)),
                                dRotate: jbAD.dRotate && jbAD.dRotate[customer._id],
                                dSent: jbAD.dSent && jbAD.dSent[customer._id],
                                jbAD,
                                coupon
                            })
                        })
                    })
                })
            })
            WebSoc.SEND('search',{ DB: 'jb-coupons', find: { customer_id:customer._id }, orderby: { update: -1  } },coupons => {
                this.coupons = coupons;
                console.log('coupons',JSON.parse(JSON.stringify(coupons)));
            });
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { menu: 1 } },client => {
                client.menu.forEach(m => m.awarded = 0);
                this.loyalty = client.menu.filter(l => l.page == 'loyalty');
                this.checkLoyalty()
            })
        },
        checkLoyalty () {
            if ( this.customer && this.loyalty.length > 0 ) {
                this.loyalty.forEach(l => {
                    l.awarded = this.customer[l.campaign_id] || 0;
                    console.log('awarded',l.text,l.campaign_id,this.customer[l.campaign_id]);
                });
                this.$forceUpdate();
            }
        },
        exit () {
            this.$emit('exit')
        }
    }

}    
</script>

<style lang="scss">
.coupon-item {
    display: grid;grid-template-columns: 160px 300px 100px 160px 160px 90px;
    width: calc(100% - 10px);
    padding: 5px;
    &:nth-child(even) { background-color: rgba(200,200,200,0.3); }
}
.list-detail {
    background-color: white;
    border-top: 1px solid #c0c0c0;
    border-bottom: 1px solid #c0c0c0;
    .list-detail-container {
        position: relative;
        width: calc(100% - 40px);
        border: 1px solid #c0c0c0;
        margin: 20px;
        header {
            width: 100%;
            border-bottom: 1px solid #c0c0c0;
            p {
                line-height: 38px;
                margin-left: 10px;
            }
        }
    }
}

</style>